import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Paper,
  Fade,
} from '@mui/material';
import VerificationBadge from './VerificationBadge';

function FeaturedNFTCard({ nft }) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.stopPropagation();
    if (nft.collectionId) {
      navigate(`/collection/${nft.collectionId}`);
    } else {
      navigate(`/item/${nft.id}`);
    }
  };

  return (
    <Paper
      sx={{
        position: 'relative',
        height: '400px',
        backgroundImage: `url(${nft.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'flex-end',
        cursor: 'pointer',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 60%, rgba(0,0,0,0.8) 100%)',
          pointerEvents: 'none',
        }
      }}
      onClick={handleClick}
    >
      <Fade in timeout={1000}>
        <Box
          sx={{
            position: 'relative',
            p: 4,
            width: '100%',
            color: 'white',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography variant="h3" component="h2" sx={{ 
              mr: 1,
              fontSize: { xs: '2rem', md: '2.5rem' }
            }}>
              {nft.title}
            </Typography>
            <VerificationBadge />
          </Box>
          <Typography variant="h5" sx={{ mb: 2 }}>
            {nft.price}
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Created by {nft.creator}
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={handleClick}
            sx={{
              backgroundColor: '#FF2E63',
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255, 46, 99, 0.9)',
                boxShadow: '0 0 20px rgba(255, 46, 99, 0.5)'
              }
            }}
          >
            View Details
          </Button>
        </Box>
      </Fade>
    </Paper>
  );
}

export default FeaturedNFTCard;
